import {
  Box,
  Button,
  useBoolean,
  VStack,
  Alert,
  AlertIcon,
  Progress,
  useToast,
} from "@chakra-ui/react";
import { useGlobals } from "hooks/helpers/useGlobals";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import CardPage from "v2/components/pages/CardPage";
import { Col } from "v2/components/shared/Col";
import SimpleFormGenerator from "v2/components/shared/SimpleFormGenerator";
import { useHashData } from "v2/hooks/helpers/useHashData";
import { apiClient } from "v2/services/clients/apiClient";
import { axiosWebsite } from "helpers/axiosInstances";
import { showLoading, setGlobalMessage, clearLoading } from "redux/actions";

import { isUnauthorized } from "helpers/errors";
import { validateFild } from "helpers/validFilds";
import { Permissions } from "interfaces/web/permission";
import { createCustomerSearchPickerMulti } from "v2/services/app/factories/forms/createCustomerSearchPickerMulti";
import {
  isReportRequestExpired,
  saveReportRequest,
} from "v2/services/helpers/reportsRequest";

const ListReportsPage: React.FC = () => {
  const { user, hasPermissions, isAutorizado } = useGlobals();

  const permDIRF = isAutorizado
    ? hasPermissions([Permissions.REPORT_DIRF])
    : true;
  const permPAGREC = isAutorizado
    ? hasPermissions([Permissions.REPORT_PAGREG])
    : true;
  const permECF = isAutorizado
    ? hasPermissions([Permissions.REPORT_ECF])
    : true;
  const permVOTORANTIM = isAutorizado
    ? hasPermissions([Permissions.REPORT_VOTORANTIM])
    : true;
  const permIMPEXP = isAutorizado
    ? hasPermissions([Permissions.REPORT_IMPEXP])
    : true;
  const permIR = isAutorizado ? hasPermissions([Permissions.REPORT_IR]) : true;
  const permNF = isAutorizado ? hasPermissions([Permissions.REPORT_NF]) : true;
  const permTRF = isAutorizado
    ? hasPermissions([Permissions.REPORT_TRF])
    : true;
  const permVCONT = isAutorizado
    ? hasPermissions([Permissions.REPORT_VOLCONTRACT])
    : true;
  const permOPERATION = isAutorizado
    ? hasPermissions([Permissions.REPORT_OPERATION])
    : true;

  const [hidden, setDevHidden] = useState<boolean>(true);
  const dispatch = useDispatch();
  const history = useHistory();
  const { hashData, redirect } = useHashData();
  const [isLoading, loading] = useBoolean();
  const [mode, setMode] = useState<
    | "one"
    | "two"
    | "three"
    | "four"
    | "five"
    | "six"
    | "seven"
    | "eight"
    | "nine"
    | "ten"
    | "eleven"
    | "twelve"
    | "thirteen"
  >("one");
  const [modeObj, setModeObj] = useState<any>({ select: "one" });
  const toast = useToast();

  function generateLastFiveYears() {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 5 }, (_, i) => {
      const year = currentYear - i - 1;
      return {
        label: () => String(year),
        value: String(year),
      };
    });
  }

  useEffect(() => {
    const date = new Date().toISOString().split("T")[0];
    redirect({
      start_date: date,
      end_date: date,
    });
  }, [mode]);

  useEffect(() => {
    const date = new Date().toISOString().split("T")[0];
    redirect({
      customer: user.permission_group_company?.includes(
        Number(user.id_syscambio)
      )
        ? {
            corporate_name:
              user.cad_type === "AUTORIZADO"
                ? user.company_name
                : user.user_name,
            document:
              user.cad_type === "AUTORIZADO"
                ? user.company_document
                : user.document,
            id_syscambio: user.id_syscambio,
          }
        : undefined,
      start_date: date,
      end_date: date,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function comboList() {
    const list = [
      {
        label: () => "Pagadores e Recebedores",
        value: "one",
        view: permPAGREC,
      },
      {
        label: () => "Nota de Corretagem",
        value: "two",
        view: permNF,
      },
      {
        label: () => "Informe de Redimentos",
        value: "four",
        view: permIR,
      },
      {
        label: () => "DIRF",
        value: "seven",
        view: permDIRF,
      },
      {
        label: () => "Pagamento Antecipado – Importação/Exportação.",
        value: "five",
        view: permIMPEXP,
      },
      {
        label: () => "Volumetria de Contratos",
        value: "six",
        view: permVCONT,
      },
      {
        label: () => "ECF Y520",
        value: "eight",
        view: permECF,
      },
      {
        label: () => "Operações",
        value: "nine",
        view: permVOTORANTIM,
      },
      {
        label: () => "Tributos de Remessas Financeiras",
        value: "ten",
        view: permTRF,
      },
      {
        label: () => "Relatório de Operação por Banco",
        value: "eleven",
        view: permVCONT,
      },
      {
        label: () => "Documentos da Operação",
        value: "twelve",
        view: permVCONT,
      },
      {
        label: () => "Relatório de Operações",
        value: "thirteen",
        view: permOPERATION,
      },
    ];

    return list.filter((e) => e.view === true);
  }

  function alertSelectMulti() {
    return (
      <>
        {hashData.customer?.length! > 1 && (
          <Alert status="warning" mt={2}>
            <AlertIcon />
            Será enviado um e-mail para cada empresa selecionada.
          </Alert>
        )}
      </>
    );
  }

  async function exportPayerReceiver() {
    try {
      if (!validateFild(hashData, ["customer"])) {
        toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return null;
      }

      loading.on();
      const param = {
        list_document: hashData.customer?.map(
          (e: any) => `${e.id_syscambio}|${e.document.replace(/\D/g, "")}`
        ),
        to: user.email,
      };

      if (isReportRequestExpired("payer", param)) {
        return toast({
          title: "Filtro",
          description:
            "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
      }

      await apiClient.payerReceiversReport.queue(param);

      saveReportRequest("payer", param);

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
    } finally {
      loading.off();
    }
  }
  async function exportFiscalNotes(params: any) {
    try {
      if (
        !validateFild(hashData, [
          "customer",
          "note_type",
          "data_type",
          "start_date",
          "end_date",
        ])
      ) {
        toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return null;
      }

      loading.on();
      const param = {
        id_syscambio: params.customer?.map((e: any) => e.id_syscambio),
        note_type: params.note_type,
        data_type: params.data_type,
        start_date: params.start_date,
        end_date: params.end_date,
        to: user.email,
      };

      if (isReportRequestExpired("fiscalNotes", param)) {
        return toast({
          title: "Filtro",
          description:
            "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
      }

      await apiClient.fiscalNotes.queue(param);

      saveReportRequest("fiscalNotes", param);

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error) {
    } finally {
      loading.off();
    }
  }
  async function callIncomeReport() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "type_inf", "base"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const list = hashData.customer?.map((e: any) => e.id_syscambio) ?? [];

      for (const element of list) {
        const body: any = {
          Name: "queue_informe_rendimentos_direct",
          Priority: "Normal",
          Reference: `${element} - ${
            new Date()
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0]
          }`,
          SpecificContent: {
            modelo_informe_rendimentos: hashData.type_inf,
            ano_base: hashData.base,
            data_geracao: new Date()
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            cliente: element,
            ordem: "NOME DO CLIENTE",
            email_solicitante: user.email,
          },
        };

        if (isReportRequestExpired("callIncomeReport", body)) {
          return toast({
            title: "Filtro",
            description:
              "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }

        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        };
        await axiosWebsite.post(`/queue`, body, config);

        saveReportRequest("callIncomeReport", body);
      }

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function callImpExp() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (
        !validateFild(hashData, [
          "customer",
          "type",
          "type_export",
          "start_date",
          "end_date",
        ])
      ) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      const startDate = new Date(hashData.start_date);
      const endDate = new Date(hashData.end_date);
      const maxMonths = 3;
      const diffMonths =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());
      if (diffMonths > maxMonths || diffMonths < 0) {
        return toast({
          title: "Filtro",
          description: "O período selecionado deve ter no máximo 3 meses.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const list = hashData.customer?.map((e: any) => e.id_syscambio) ?? [];

      for (const element of list) {
        const body: any = {
          Name:
            hashData.type === "imp" ? "importacao_direct" : "exportacao_direct",
          Priority: "Normal",
          Reference: `${element} - ${
            new Date()
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0]
          }`,
          SpecificContent: {
            pdf_csv: hashData.type_export,
            periodo_a: new Date(hashData.start_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            periodo_b: new Date(hashData.end_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            cod_cliente: element,
            email_solicitante: user.email,
          },
        };
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        };

        if (isReportRequestExpired("callImpExp", body)) {
          return toast({
            title: "Filtro",
            description:
              "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }

        await axiosWebsite.post(`/queue`, body, config);

        saveReportRequest("callImpExp", body);
      }

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function callVolumatric() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "start_date", "end_date"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const body: any = {
        list_document: hashData.customer?.map((e: any) =>
          e.document.replace(/\D/g, "")
        ),
        initial_date: hashData.start_date,
        end_date: hashData.end_date,
        to: user.email,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };

      if (isReportRequestExpired("callVolumatric", body)) {
        return toast({
          title: "Filtro",
          description:
            "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
      }

      await axiosWebsite.post(
        `queue/report/operation-volumetric`,
        body,
        config
      );

      saveReportRequest("callVolumatric", body);

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function queueVolumatricBank() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "start_date", "end_date"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };

      const body: any = {
        list_document: hashData.customer?.map((e: any) =>
          e.document.replace(/\D/g, "")
        ),
        initial_date: hashData.start_date,
        end_date: hashData.end_date,
        to: user.email,
      };

      await axiosWebsite.post(`queue/report/operation-bank`, body, config);

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function callDirf() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "month", "base"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };

      const body: any = {
        list_document: hashData.customer?.map((e: any) =>
          e.document.replace(/\D/g, "")
        ),
        month: hashData.month,
        year: hashData.base,
        to: user.email,
      };

      if (isReportRequestExpired("callDirf", body)) {
        return toast({
          title: "Filtro",
          description:
            "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
      }

      await axiosWebsite.post(`/queue/report/dirf`, body, config);

      saveReportRequest("callDirf", body);
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function callECFY520() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "start_date", "end_date"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      const startDate = new Date(hashData.start_date);
      const endDate = new Date(hashData.end_date);
      const maxMonths = 3;
      const diffMonths =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());
      if (diffMonths > maxMonths || diffMonths < 0) {
        return toast({
          title: "Filtro",
          description: "O período selecionado deve ter no máximo 3 meses.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const list = hashData.customer?.map((e: any) => e.id_syscambio) ?? [];

      for (const element of list) {
        const body: any = {
          Name: "ECF_",
          Priority: "Normal",
          Reference: `${element} - ${
            new Date()
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0]
          }`,
          SpecificContent: {
            periodo_a: new Date(hashData.start_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            periodo_b: new Date(hashData.end_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            cod_cliente: element,
            email_solicitante: user.email,
          },
        };
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        };

        if (isReportRequestExpired("callECFY520", body)) {
          return toast({
            title: "Filtro",
            description:
              "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }

        await axiosWebsite.post(`/queue`, body, config);

        saveReportRequest("callECFY520", body);
      }

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function callOperationDocs() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "start_date", "end_date"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      const startDate = new Date(hashData.start_date);
      const endDate = new Date(hashData.end_date);
      const maxMonths = 3;
      const diffMonths =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());
      if (diffMonths > maxMonths || diffMonths < 0) {
        return toast({
          title: "Filtro",
          description: "O período selecionado deve ter no máximo 3 meses.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const list = hashData.customer?.map((e: any) => e.id_syscambio) ?? [];

      for (const element of list) {
        const body: any = {
          Name: "callOperationDocs",
          Priority: "Normal",
          Reference: `${element} - ${
            new Date()
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0]
          }`,
          SpecificContent: {
            periodo_a: new Date(hashData.start_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            periodo_b: new Date(hashData.end_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            cod_cliente: element,
            email_solicitante: user.email,
          },
        };
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        };

        if (isReportRequestExpired("callOperationDocs", body)) {
          return toast({
            title: "Filtro",
            description:
              "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }

        await axiosWebsite.post(`/queue`, body, config);

        saveReportRequest("callOperationDocs", body);
      }

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function callTRF() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "start_date", "end_date"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      const startDate = new Date(hashData.start_date);
      const endDate = new Date(hashData.end_date);
      const maxMonths = 3;
      const diffMonths =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());
      if (diffMonths > maxMonths || diffMonths < 0) {
        return toast({
          title: "Filtro",
          description: "O período selecionado deve ter no máximo 3 meses.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const list = hashData.customer?.map((e: any) => e.id_syscambio) ?? [];

      for (const element of list) {
        const body: any = {
          Name: "tributos_financeiros_queue",
          Priority: "Normal",
          Reference: `${element} - ${
            new Date()
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0]
          }`,
          SpecificContent: {
            periodo_a: new Date(hashData.start_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            periodo_b: new Date(hashData.end_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0],
            cod_cliente: element,
            email_solicitante: user.email,
          },
        };
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        };

        if (isReportRequestExpired("callTRF", body)) {
          return toast({
            title: "Filtro",
            description:
              "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }

        await axiosWebsite.post(`/queue`, body, config);

        saveReportRequest("callTRF", body);
      }

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function queueOperationPosfec() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "start_date", "end_date"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const body: any = {
        list_document: hashData.customer?.map((e: any) =>
          e.document.replace(/\D/g, "")
        ),
        initial_date: hashData.start_date,
        end_date: hashData.end_date,
        to: user.email,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };

      if (isReportRequestExpired("queueOperationPosfec", body)) {
        return toast({
          title: "Filtro",
          description:
            "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
      }

      await axiosWebsite.post(`queue/report/operation-posfec`, body, config);

      saveReportRequest("queueOperationPosfec", body);

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  async function callReportOperation() {
    try {
      if (hidden === true) {
        setDevHidden(false);
      }

      if (!validateFild(hashData, ["customer", "start_date", "end_date"])) {
        return toast({
          title: "Filtro",
          description: "Todos os campos da consulta são necessarios!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
          subMessage: "",
        })
      );

      const list = hashData.customer?.map((e: any) => e.id_syscambio) ?? [];

      for (const element of list) {
        const body: any = {
          Name: "Relatorio_technip",
          Priority: "Normal",
          Reference: `${element} - ${
            new Date()
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0]
          }`,
          SpecificContent: {
            data_inicio: hashData.start_date,
            data_final: hashData.end_date,
            codigo_cliente: element,
            email: user.email,
          },
        };

        if (isReportRequestExpired("callReportOperation", body)) {
          return toast({
            title: "Filtro",
            description:
              "Já foi solicitado um relatório com esses filtros nos últimos 10 minutos.",
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }

        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        };
        await axiosWebsite.post(`/queue`, body, config);

        saveReportRequest("callReportOperation", body);
      }

      toast({
        title: "Solicitação",
        description:
          "Sua solicitação foi envia, por favor, aguarde o retorno por e-mail!",
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao buscar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  }
  if (isLoading)
    return (
      <CardPage title={"Dados do Contrato (Fonte SYSCambio)"}>
        <Progress isIndeterminate colorScheme={"secondary"} h={1} />
      </CardPage>
    );

  return (
    <CardPage
      title={
        mode === "one"
          ? "Relatório de Pagadores e Recebedores"
          : mode === "two"
          ? "Relatório de Nota de Corretagem"
          : mode === "three"
          ? "Relatório de Operações"
          : mode === "four"
          ? "Informe de Redimentos"
          : mode === "five"
          ? "Pagamento Antecipado – Importação/Exportação."
          : mode === "six"
          ? "Relatório de Volumetria de Contratos"
          : mode === "seven"
          ? "Relatório DIRF"
          : mode === "eight"
          ? "Relatório pagamentos/Recebimentos do Exterior ou de Não residentes (ECF Y520)"
          : mode === "nine"
          ? "Relatório de Operações"
          : mode === "ten"
          ? "Tributos de Remessas Financeiras"
          : mode === "eleven"
          ? "Relatório de Operação por Banco"
          : mode === "twelve"
          ? "Documentos da Operação"
          : mode === "thirteen"
          ? "Relatório de Operações"
          : "Relatórios"
      }
      _headerRight={
        <VStack spacing={4} align="stretch">
          <Box w={"300px"} h="40px" mb={8} mt={3}>
            <SimpleFormGenerator
              rows={[
                {
                  columns: 1,
                  fields: [
                    {
                      type: "select",
                      label: "Relatórios",
                      name: "select",
                      options: comboList(),
                    },
                  ],
                },
              ]}
              value={modeObj}
              onChange={(v) => {
                setModeObj({ select: v.select });
                setMode(v.select);
              }}
            />
          </Box>
        </VStack>
      }
    >
      <Col px={2} w={"99.2%"}>
        {mode === "one" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 2,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              const nextParams: any = { ...v };
              nextParams.customer = v.customer;
              redirect(nextParams);
            }}
          />
        ) : mode === "two" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 2,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                ],
              },
              {
                columns: 4,
                fields: [
                  {
                    type: "select",
                    label: "Tipo de Notas",
                    name: "note_type",
                    options: [
                      {
                        label: () => "Corretagem",
                        value: "C",
                      },
                      {
                        label: () => "Serviço",
                        value: "S",
                      },
                    ],
                  },
                  {
                    type: "select",
                    label: "Período de",
                    name: "data_type",
                    options: [
                      {
                        label: () => "Emissão",
                        value: "E",
                      },
                      {
                        label: () => "Vencimento",
                        value: "V",
                      },
                    ],
                  },
                  {
                    type: "date",
                    label: "Data Inicial",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "Data Final",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              const nextParams: any = { ...v };
              nextParams.customer = v.customer;

              redirect(nextParams);
            }}
          />
        ) : mode === "four" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 4,
                fields: [
                  {
                    type: "select",
                    label: "Modelo do Informe",
                    name: "type_inf",
                    options: [
                      {
                        label: () => "Corretora",
                        value: "Corretora",
                      },
                      {
                        label: () => "Receita",
                        value: "Receita",
                      },
                    ],
                  },
                  {
                    type: "select",
                    label: "Ano Base",
                    name: "base",
                    options: generateLastFiveYears(),
                  },
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }

              const nextParams: any = { ...v };

              nextParams.customer = v.customer;

              redirect(nextParams);
            }}
          />
        ) : mode === "five" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 4,
                fields: [
                  {
                    type: "select",
                    label: "Tipo",
                    name: "type",
                    options: [
                      {
                        label: () => "Exportação",
                        value: "exp",
                      },
                      {
                        label: () => "Importação",
                        value: "imp",
                      },
                    ],
                  },
                  {
                    type: "select",
                    label: "Tipo de Exportação",
                    name: "type_export",
                    options: [
                      {
                        label: () => "PDF",
                        value: "PDF",
                      },
                      {
                        label: () => "CSV",
                        value: "CSV",
                      },
                    ],
                  },
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                ],
              },
              {
                columns: 4,
                fields: [
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              nextParams.customer = v.customer;

              redirect(nextParams);
            }}
          />
        ) : mode === "six" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 3,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              if (v.customer) {
                nextParams.customer = v.customer;
              }

              redirect(nextParams);
            }}
          />
        ) : mode === "seven" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 4,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                  {
                    type: "select",
                    label: "Mês",
                    name: "month",
                    options: [
                      {
                        label: () => "01",
                        value: 0,
                      },
                      {
                        label: () => "02",
                        value: 1,
                      },
                      {
                        label: () => "03",
                        value: 2,
                      },
                      {
                        label: () => "04",
                        value: 3,
                      },
                      {
                        label: () => "05",
                        value: 4,
                      },
                      {
                        label: () => "06",
                        value: 5,
                      },
                      {
                        label: () => "07",
                        value: 6,
                      },
                      {
                        label: () => "08",
                        value: 7,
                      },
                      {
                        label: () => "09",
                        value: 8,
                      },
                      {
                        label: () => "10",
                        value: 9,
                      },
                      {
                        label: () => "11",
                        value: 10,
                      },
                      {
                        label: () => "12",
                        value: 11,
                      },
                    ],
                  },
                  {
                    type: "select",
                    label: "Ano",
                    name: "base",
                    options: generateLastFiveYears(),
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              nextParams.customer = v.customer;

              redirect(nextParams);
            }}
          />
        ) : mode === "eight" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 4,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              nextParams.customer = v.customer;

              redirect(nextParams);
            }}
          />
        ) : mode === "nine" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 3,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              if (v.customer) {
                nextParams.customer = v.customer;
              }

              redirect(nextParams);
            }}
          />
        ) : mode === "ten" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 4,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              nextParams.customer = v.customer;

              redirect(nextParams);
            }}
          />
        ) : mode === "eleven" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 3,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              if (v.customer) {
                nextParams.customer = v.customer;
              }

              redirect(nextParams);
            }}
          />
        ) : mode === "twelve" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 4,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              nextParams.customer = v.customer;

              redirect(nextParams);
            }}
          />
        ) : mode === "thirteen" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: 4,
                fields: [
                  createCustomerSearchPickerMulti(
                    user.company_id ?? user.id!,
                    user.cad_type === "AUTORIZADO"
                      ? user.permission_group_company ?? []
                      : undefined,
                    {
                      label: "Empresa",
                      name: "customer",
                      labelKey: "corporate_name",
                    }
                  ),
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              if (hidden === false) {
                setDevHidden(true);
              }
              const nextParams: any = { ...v };
              nextParams.customer = v.customer;

              redirect(nextParams);
            }}
          />
        ) : (
          <Col mt={6}>
            <Alert status="warning">
              <AlertIcon />
              Selecione um dos Relatórios:
            </Alert>
          </Col>
        )}
        {mode === "one" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                exportPayerReceiver();
              }}
            >
              Gerar Relatório de Pagadores e Recebedores
            </Button>
          </>
        ) : mode === "two" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                exportFiscalNotes(hashData);
              }}
            >
              Solicitar Relatório de Nota de Corretagem
            </Button>
          </>
        ) : mode === "four" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
              {alertSelectMulti()}
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                callIncomeReport();
              }}
            >
              Solicitar Informe de Redimentos
            </Button>
          </>
        ) : mode === "five" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
              {alertSelectMulti()}
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                callImpExp();
              }}
            >
              Solicitar Relatório
            </Button>
          </>
        ) : mode === "six" ? (
          <>
            <p>
              Atenção, esse relatório será enviado para o e-mail
              <b> {user.email} </b>
              assim que for concluído o processo de geração, caso não receba o
              mesmo, entre em contato com a Dascam para uma verificação.
            </p>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                callVolumatric();
              }}
            >
              Solicitar Relatório
            </Button>
          </>
        ) : mode === "seven" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                callDirf();
              }}
            >
              Gerar Relatório
            </Button>
          </>
        ) : mode === "eight" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
              {alertSelectMulti()}
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                callECFY520();
              }}
            >
              Solicitar Relatório
            </Button>
          </>
        ) : mode === "nine" ? (
          <>
            <p>
              Atenção, esse relatório será enviado para o e-mail
              <b> {user.email} </b>
              assim que for concluído o processo de geração, caso não receba o
              mesmo, entre em contato com a Dascam para uma verificação.
            </p>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                queueOperationPosfec();
              }}
            >
              Solicitar Relatório
            </Button>
          </>
        ) : mode === "ten" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
              {alertSelectMulti()}
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                callTRF();
              }}
            >
              Solicitar Tributos de Remessas Financeiras
            </Button>
          </>
        ) : mode === "eleven" ? (
          <>
            <p>
              Atenção, esse relatório será enviado para o e-mail
              <b> {user.email} </b>
              assim que for concluído o processo de geração, caso não receba o
              mesmo, entre em contato com a Dascam para uma verificação.
            </p>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                queueVolumatricBank();
              }}
            >
              Solicitar Relatório
            </Button>
          </>
        ) : mode === "twelve" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
              {alertSelectMulti()}
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                callOperationDocs();
              }}
            >
              Solicitar Relatório
            </Button>
          </>
        ) : mode === "thirteen" ? (
          <>
            <Col mb={6}>
              <p>
                Atenção, esse relatório será enviado para o e-mail
                <b> {user.email} </b>
                assim que for concluído o processo de geração, caso não receba o
                mesmo, entre em contato com a Dascam para uma verificação.
              </p>
            </Col>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                callReportOperation();
              }}
            >
              Solicitar Relatório de Operações
            </Button>
          </>
        ) : (
          <></>
        )}
      </Col>
    </CardPage>
  );
};

export default ListReportsPage;
